/**
 * Authentication constants
 *
 * NOTE: Tokens are stored in httpOnly cookies (server-side), not localStorage
 * NOTE: Paths are relative - base URL is set in .env (VITE_API_BASE_URL)
 */

export const AUTH_ENDPOINTS = {
  ME: '/auth/me',
  LOGIN: '/auth/login',
  LOGOUT: '/auth/logout',
  REFRESH: '/auth/refresh',
} as const;

export const USER_TYPES = {
  USER_COMPANY: 'user_company',
  USER_ADMIN: 'user_admin',
} as const;
